export const environment = {
  production: false,
  /** Identity + Card Arena API root (Card Arena admin lives under `/admin`). */
  apiBaseUrl: 'https://localhost:7072/api',
  /** Convenience alias for Card Arena admin REST (`ADMIN_API_CONTRACT`). */
  adminApiBaseUrl: 'https://localhost:7072/api/admin'
};

